import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AttachDocumentsFilesDTO } from '../model/requests-model';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class DocumentationUploadService {
  public resetUploadFileSource = new BehaviorSubject<boolean>(false);
  public resetUploadFile$ = this.resetUploadFileSource.asObservable();

  constructor(private _http: HttpClient) {}

  postSendDocs(filesToSend: AttachDocumentsFilesDTO): Observable<AttachDocumentsFilesDTO> {
    return this._http.post<AttachDocumentsFilesDTO>(
      environment.URL_BASE_REQUEST + environment.subUrlsendDocs,
      filesToSend
    );
  }

  postAuthByNumSol(numSol: string): Observable<any> {
    return this._http.post<any>(environment.URL_BASE_REQUEST + environment.subUrlAuthByNumSol, { numsol: numSol });
  }

  public getResetUploadFile(): Observable<boolean> {
    return this.resetUploadFile$;
  }

  public setResetUploadFile(value: boolean): void {
    this.resetUploadFileSource.next(value);
  }
}
